/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "fr-CA": {
        "quarter": {
          "0": "ce trimestre-ci",
          "1": "le trimestre prochain",
          "future": {
            "one": "dans {0} trimestre",
            "other": "dans {0} trimestres"
          },
          "past": {
            "one": "il y a {0} trimestre",
            "other": "il y a {0} trimestres"
          },
          "-1": "le trimestre dernier"
        },
        "quarter-short": {
          "0": "ce trim.",
          "1": "trim. prochain",
          "future": {
            "one": "dans {0} trim.",
            "other": "dans {0} trim."
          },
          "past": {
            "one": "il y a {0} trim.",
            "other": "il y a {0} trim."
          },
          "-1": "trim. dernier"
        },
        "quarter-narrow": {
          "0": "ce trim.",
          "1": "trim.prochain",
          "future": {
            "one": "+{0} trim.",
            "other": "+{0} trim."
          },
          "past": {
            "one": "-{0} trim.",
            "other": "-{0} trim."
          },
          "-1": "trim. dernier"
        },
        "second-narrow": {
          "0": "maintenant",
          "future": {
            "one": "+ {0} s",
            "other": "+{0} s"
          },
          "past": {
            "one": "-{0} s",
            "other": "-{0} s"
          }
        }
      },
      "fr": {
        "nu": ["latn"],
        "year": {
          "0": "cette année",
          "1": "l’année prochaine",
          "future": {
            "one": "dans {0} an",
            "other": "dans {0} ans"
          },
          "past": {
            "one": "il y a {0} an",
            "other": "il y a {0} ans"
          },
          "-1": "l’année dernière"
        },
        "year-short": {
          "0": "cette année",
          "1": "l’année prochaine",
          "future": {
            "one": "dans {0} a",
            "other": "dans {0} a"
          },
          "past": {
            "one": "il y a {0} a",
            "other": "il y a {0} a"
          },
          "-1": "l’année dernière"
        },
        "year-narrow": {
          "0": "cette année",
          "1": "l’année prochaine",
          "future": {
            "one": "+{0} a",
            "other": "+{0} a"
          },
          "past": {
            "one": "-{0} a",
            "other": "-{0} a"
          },
          "-1": "l’année dernière"
        },
        "quarter": {
          "0": "ce trimestre",
          "1": "le trimestre prochain",
          "future": {
            "one": "dans {0} trimestre",
            "other": "dans {0} trimestres"
          },
          "past": {
            "one": "il y a {0} trimestre",
            "other": "il y a {0} trimestres"
          },
          "-1": "le trimestre dernier"
        },
        "quarter-short": {
          "0": "ce trimestre",
          "1": "le trimestre prochain",
          "future": {
            "one": "dans {0} trim.",
            "other": "dans {0} trim."
          },
          "past": {
            "one": "il y a {0} trim.",
            "other": "il y a {0} trim."
          },
          "-1": "le trimestre dernier"
        },
        "quarter-narrow": {
          "0": "ce trimestre",
          "1": "le trimestre prochain",
          "future": {
            "one": "+{0} trim.",
            "other": "+{0} trim."
          },
          "past": {
            "one": "-{0} trim.",
            "other": "-{0} trim."
          },
          "-1": "le trimestre dernier"
        },
        "month": {
          "0": "ce mois-ci",
          "1": "le mois prochain",
          "future": {
            "one": "dans {0} mois",
            "other": "dans {0} mois"
          },
          "past": {
            "one": "il y a {0} mois",
            "other": "il y a {0} mois"
          },
          "-1": "le mois dernier"
        },
        "month-short": {
          "0": "ce mois-ci",
          "1": "le mois prochain",
          "future": {
            "one": "dans {0} m.",
            "other": "dans {0} m."
          },
          "past": {
            "one": "il y a {0} m.",
            "other": "il y a {0} m."
          },
          "-1": "le mois dernier"
        },
        "month-narrow": {
          "0": "ce mois-ci",
          "1": "le mois prochain",
          "future": {
            "one": "+{0} m.",
            "other": "+{0} m."
          },
          "past": {
            "one": "-{0} m.",
            "other": "-{0} m."
          },
          "-1": "le mois dernier"
        },
        "week": {
          "0": "cette semaine",
          "1": "la semaine prochaine",
          "future": {
            "one": "dans {0} semaine",
            "other": "dans {0} semaines"
          },
          "past": {
            "one": "il y a {0} semaine",
            "other": "il y a {0} semaines"
          },
          "-1": "la semaine dernière"
        },
        "week-short": {
          "0": "cette semaine",
          "1": "la semaine prochaine",
          "future": {
            "one": "dans {0} sem.",
            "other": "dans {0} sem."
          },
          "past": {
            "one": "il y a {0} sem.",
            "other": "il y a {0} sem."
          },
          "-1": "la semaine dernière"
        },
        "week-narrow": {
          "0": "cette semaine",
          "1": "la semaine prochaine",
          "future": {
            "one": "+{0} sem.",
            "other": "+{0} sem."
          },
          "past": {
            "one": "-{0} sem.",
            "other": "-{0} sem."
          },
          "-1": "la semaine dernière"
        },
        "day": {
          "0": "aujourd’hui",
          "1": "demain",
          "2": "après-demain",
          "future": {
            "one": "dans {0} jour",
            "other": "dans {0} jours"
          },
          "past": {
            "one": "il y a {0} jour",
            "other": "il y a {0} jours"
          },
          "-2": "avant-hier",
          "-1": "hier"
        },
        "day-short": {
          "0": "aujourd’hui",
          "1": "demain",
          "2": "après-demain",
          "future": {
            "one": "dans {0} j",
            "other": "dans {0} j"
          },
          "past": {
            "one": "il y a {0} j",
            "other": "il y a {0} j"
          },
          "-2": "avant-hier",
          "-1": "hier"
        },
        "day-narrow": {
          "0": "aujourd’hui",
          "1": "demain",
          "2": "après-demain",
          "future": {
            "one": "+{0} j",
            "other": "+{0} j"
          },
          "past": {
            "one": "-{0} j",
            "other": "-{0} j"
          },
          "-2": "avant-hier",
          "-1": "hier"
        },
        "hour": {
          "0": "cette heure-ci",
          "future": {
            "one": "dans {0} heure",
            "other": "dans {0} heures"
          },
          "past": {
            "one": "il y a {0} heure",
            "other": "il y a {0} heures"
          }
        },
        "hour-short": {
          "0": "cette heure-ci",
          "future": {
            "one": "dans {0} h",
            "other": "dans {0} h"
          },
          "past": {
            "one": "il y a {0} h",
            "other": "il y a {0} h"
          }
        },
        "hour-narrow": {
          "0": "cette heure-ci",
          "future": {
            "one": "+{0} h",
            "other": "+{0} h"
          },
          "past": {
            "one": "-{0} h",
            "other": "-{0} h"
          }
        },
        "minute": {
          "0": "cette minute-ci",
          "future": {
            "one": "dans {0} minute",
            "other": "dans {0} minutes"
          },
          "past": {
            "one": "il y a {0} minute",
            "other": "il y a {0} minutes"
          }
        },
        "minute-short": {
          "0": "cette minute-ci",
          "future": {
            "one": "dans {0} min",
            "other": "dans {0} min"
          },
          "past": {
            "one": "il y a {0} min",
            "other": "il y a {0} min"
          }
        },
        "minute-narrow": {
          "0": "cette minute-ci",
          "future": {
            "one": "+{0} min",
            "other": "+{0} min"
          },
          "past": {
            "one": "-{0} min",
            "other": "-{0} min"
          }
        },
        "second": {
          "0": "maintenant",
          "future": {
            "one": "dans {0} seconde",
            "other": "dans {0} secondes"
          },
          "past": {
            "one": "il y a {0} seconde",
            "other": "il y a {0} secondes"
          }
        },
        "second-short": {
          "0": "maintenant",
          "future": {
            "one": "dans {0} s",
            "other": "dans {0} s"
          },
          "past": {
            "one": "il y a {0} s",
            "other": "il y a {0} s"
          }
        },
        "second-narrow": {
          "0": "maintenant",
          "future": {
            "one": "+{0} s",
            "other": "+{0} s"
          },
          "past": {
            "one": "-{0} s",
            "other": "-{0} s"
          }
        }
      }
    },
    "availableLocales": ["fr-BE", "fr-BF", "fr-BI", "fr-BJ", "fr-BL", "fr-CA", "fr-CD", "fr-CF", "fr-CG", "fr-CH", "fr-CI", "fr-CM", "fr-DJ", "fr-DZ", "fr-GA", "fr-GF", "fr-GN", "fr-GP", "fr-GQ", "fr-HT", "fr-KM", "fr-LU", "fr-MA", "fr-MC", "fr-MF", "fr-MG", "fr-ML", "fr-MQ", "fr-MR", "fr-MU", "fr-NC", "fr-NE", "fr-PF", "fr-PM", "fr-RE", "fr-RW", "fr-SC", "fr-SN", "fr-SY", "fr-TD", "fr-TG", "fr-TN", "fr-VU", "fr-WF", "fr-YT", "fr"],
    "aliases": {},
    "parentLocales": {}
  });
}